import { TableHeadersType } from "../../tableHeadersType";

export const PROFIT_LOSS_HEADERS: TableHeadersType[] = [
  {
    label: 'Account Name',
    value: 'ledger_name',
    checked: true,
    defaultChecked: true
  },
  {
    label: 'Amount',
    value: 'total_amount',
    checked: true,
    defaultChecked: true
  },
];